import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

export const fetchSeguroSaludSelect = async () => {
  const query = `
    query {
      allSegurosalud {
        id
        descripcion
        codigo
      }
    }
  `;

  try {
    const response = await axios.post(rutas.axios + 'api', { query });

    return response.data.data.allSegurosalud.map(
      item => ({
        value: item.id,
        text : item.descripcion,
        codigo : item.codigo
      })
    );
   

  } catch (error) {
    console.error("Error fetching Seguro Salud:", error);
    return error;
  }
}